<mapfre-generic-information-template
[headerImageURL]="'./assets/img/images/headers/about.png'"
[backButtonUrl]="'/information'"
[type]="'page'">
<h1 class="information-title">{{ 'INFORMATION_ABOUT_1' | translate }}</h1>
<div class="row information-content padding-horizontal ph36">
  <div class="col">
    <p class="information-par-margin">
        {{ 'INFORMATION_ABOUT_2' | translate }}
    </p>
    <p class="information-par-margin">
      <strong>{{ 'INFORMATION_ABOUT_3' | translate }}</strong><br />
      <strong>{{ 'INFORMATION_ABOUT_4' | translate }}</strong><br />
      {{ 'INFORMATION_ABOUT_5' | translate }}
    </p>
    <p class="no-margin-bottom information-par-margin">
      <strong>{{ 'INFORMATION_ABOUT_6' | translate }}</strong><br />
      <strong>{{ 'INFORMATION_ABOUT_7' | translate }}</strong>
    </p>
    <ul class="information-list information-par-margin">
        <li>{{ 'INFORMATION_ABOUT_8' | translate }}</li>
        <li>{{ 'INFORMATION_ABOUT_9' | translate }}</li>
        <li>{{ 'INFORMATION_ABOUT_10' | translate }}</li>
        <li>{{ 'INFORMATION_ABOUT_11' | translate }}</li>
        <li>{{ 'INFORMATION_ABOUT_12' | translate }}</li>
        <li>{{ 'INFORMATION_ABOUT_13' | translate }}</li>
    </ul>
  </div>
</div>
</mapfre-generic-information-template>
